<template>
  <div class="media-with-titled-markdown">
    <Media
      :path="resource.columns.video || resource.columns.path"
      :small="resource.columns.small"
      autoplay
    />
    <div v-if="resource.children && resource.children[0]" class="media-with-titled-markdown__content">
      <TitledMarkdown :title-size="2" :resource="resource.children[0]" />
    </div>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import TitledMarkdown from 'beisheim/components/blocks/titled-markdown'
import Media from 'beisheim/components/elements/media'

export default {
  components: {
    Media,
    TitledMarkdown
  },
  mixins: [ editable ]
}
</script>

<style lang="scss">
@import 'beisheim/scss/breakpoints';

.media-with-titled-markdown {
  position: relative;

  &__markdown {
    pointer-events: all;
  }

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-shadow: 0 0 1rem rgba(0,0,0,0.75);
  }

  @include to(3) {
    .headline--size-2 {
      font-size: 1.25rem;
    }

    .headline--size-4 {
      font-size: 1.75rem;
    }

    .titled-markdown__text--large {
      font-size: 1.125rem;
    }
  }
}
</style>
